<ifbp-dashboard-page-shell [page]="page$ | async" [asOfUtc]="(vm$ | async)?.asOfUtc ?? null">
  <ng-container *ngIf="vm$ | async as vm" [ngSwitch]="vm.state">
    <ifbp-partner-scorecard-skeleton *ngSwitchCase="VmState.LOADING"></ifbp-partner-scorecard-skeleton>
    <ifbp-snapshot-error-card
      *ngSwitchCase="VmState.ERROR"
      [message]="vm.errorMessage"
      fallbackMessage="Your partner scorecard is unavailable right now. Change the scope to try again."
    ></ifbp-snapshot-error-card>
    <div class="scorecard" *ngSwitchCase="VmState.DATA">
      <ifbp-scorecard-bar-chart
        *ngFor="let chart of vm.data?.charts; trackBy: trackByChart"
        [vm]="chart"
      ></ifbp-scorecard-bar-chart>
      <ifbp-scorecard-bar-chart
        [vm]="vm.data?.declined"
        [moreLabel]="vm.data?.declined?.moreLabel"
      ></ifbp-scorecard-bar-chart>
    </div>
  </ng-container>
</ifbp-dashboard-page-shell>
